// composables/usePageTranslations.ts
export const usePageTranslations = () => {
  return useState<Record<string, { slug: string; file: string }> | null>(
    'page-translations',
    () => null
  );
};